export default "__VITE_ASSET__654807ed__"